import React from 'react';
import isEqual from 'lodash.isequal';

import { ReactComponent as IconStar } from 'icons/icon-star.svg';
import { ReactComponent as InfoIcon } from 'icons/icon-info.svg';

import getBreakdownLabel from 'helpers/getBreakdownLabel';
import useMedia from 'hooks/useMedia';

import Span from 'components/elements/span';
import Box from 'components/elements/Box';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import {
  EditBtn,
  TooltipTitleBox,
  TerritoryTitle,
  ListOfTooltipEntities,
  SavedItem,
} from 'components/base/TopicFiltersDropdown/RegionDropdown';
import { IconAndTextWrapper, Label } from './SavedDSPLists.style';

interface ISavedDSPListsProps {
  savedCustomDSPLists?: any;
  customers?: any;
  selectedDSPs?: any;
  selectedCustomDSPList?: any;
  onSelectCustomDSPList: Function;
  switchToEditView?: Function;
}

const TooltipContent = ({
  DSPList,
  customDSPId,
  switchToEditView,
  customers,
}: {
  DSPList: string[];
  customDSPId?: string;
  switchToEditView?: Function;
  customers: any;
}): JSX.Element => {
  const listOfCustomers = DSPList.map((customer: string) =>
    getBreakdownLabel(customer, customers)
  ).join('\n');

  const onClickFunction = (): void => {
    if (customDSPId && switchToEditView) switchToEditView(customDSPId);
  };

  return (
    <Box>
      <TooltipTitleBox>
        <TerritoryTitle>DSPs</TerritoryTitle>
        {customDSPId && switchToEditView && (
          <EditBtn fromTooltip onClick={onClickFunction}>
            Edit
          </EditBtn>
        )}
      </TooltipTitleBox>
      <ListOfTooltipEntities>{listOfCustomers}</ListOfTooltipEntities>
    </Box>
  );
};

const SavedDSPLists: React.FC<ISavedDSPListsProps> = (props) => {
  const isSmallScreen = useMedia('(max-width: 50em)');
  const {
    savedCustomDSPLists,
    customers,
    switchToEditView,
    selectedDSPs,
    selectedCustomDSPList,
    onSelectCustomDSPList,
  } = props;

  return (
    <>
      <Label>MY SAVED DSP LISTS</Label>
      {savedCustomDSPLists.map((customDSP: any) => {
        let isSelected = false;
        if (customDSP.id === selectedCustomDSPList?.id) {
          // in case if country selected (with different DSPs) and selectedCustomDSPList exists do not show selected
          isSelected = isEqual(selectedDSPs, selectedCustomDSPList.DSPList);
        }
        return (
          <SavedItem
            key={customDSP.id}
            onClick={(): void => onSelectCustomDSPList(customDSP)}
          >
            <IconAndTextWrapper isSelected={isSelected}>
              {/** Temporary fix
               * TODO - please, remove this fix once the limit of maximum symbols is set
               */}
              <Box minWidth="17px">
                <IconStar />
              </Box>
              <Span marginLeft="15px">{customDSP.displayName}</Span>
            </IconAndTextWrapper>
            {!isSmallScreen && customDSP.DSPList?.length > 0 && (
              <Span onClick={(e): any => e.stopPropagation()}>
                <TippyToolTip
                  tooltipContent={
                    <TooltipContent
                      DSPList={customDSP.DSPList}
                      customDSPId={customDSP.id}
                      switchToEditView={switchToEditView}
                      customers={customers}
                    />
                  }
                  delay={[250, 250]}
                  placement="right"
                  maxWidth="max-content"
                  enabled
                >
                  <Box alignSelf="auto" display="flex" ml={3}>
                    <InfoIcon display="inline-flex" width={16} height={16} />
                  </Box>
                </TippyToolTip>
              </Span>
            )}

            {isSmallScreen && customDSP.id && customDSP.DSPList.length > 0 && (
              <Span marginLeft="auto">
                <Box
                  alignSelf="auto"
                  display="flex"
                  ml={3}
                  mr={1}
                  onClick={(): void =>
                    !!switchToEditView && switchToEditView(customDSP.id)
                  }
                >
                  <EditBtn>Edit</EditBtn>
                </Box>
              </Span>
            )}
          </SavedItem>
        );
      })}
    </>
  );
};

export default SavedDSPLists;
